var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-center p-5 border-b"},[_c('SearchInputRounded',{staticClass:"w-full flex-shrink",model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }